/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import BaseValidator from 'ember-cp-validations/validators/base';
import { inject as service } from '@ember/service';

const RuleActionIsValid = BaseValidator.extend({
  intl: service(),

  validate(value, options) {
    if (value && !value.get('isValid')) {
      if (options.message) {
        return this.intl.t(options.message);
      } else {
        return 'Your action is invalid';
      }
    }
    return true;
  },
});

RuleActionIsValid.reopenClass({
  getDependentsFor() {
    return ['model.action.isValid'];
  },
});

export default RuleActionIsValid;
